import { createContext } from 'react';
import { Dimensions } from 'react-native';

const window = Dimensions.get('window');
export const DimensionsContext = createContext({ ...window, size: 'small' });
